export default "__VITE_ASSET__plNZYcy2__"